// extracted by mini-css-extract-plugin
export default {"editor":"Editor_editor__IrY+R","saveBtn":"Editor_saveBtn__VJaAw"};